"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("@pbl/pbl-react-core/lib/models/activity/types");
var redux_persist_1 = require("redux-persist");
var storage_1 = __importDefault(require("redux-persist/lib/storage"));
var action_type_util_1 = require("../../../redux/action-type.util");
var INITIAL_STATE = {};
var ActivityStateReducer = function (state, action) {
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case (0, action_type_util_1.REQUEST)(types_1.GET_ACTIVITY_LIST_V2):
        case (0, action_type_util_1.REQUEST)(types_1.GET_ACTIVITY_FEATURED):
        case (0, action_type_util_1.REQUEST)(types_1.GET_BONUS_ACTIVITY):
            return __assign(__assign({}, state), { loading: true });
        case (0, action_type_util_1.SUCCESS)(types_1.GET_ACTIVITY):
        case (0, action_type_util_1.SUCCESS)(types_1.GET_ACTIVITY_WITH_FREQ_CAP):
        case (0, action_type_util_1.SUCCESS)(types_1.CREDIT):
            return __assign(__assign({}, state), { activities: action.payload.activities });
        case types_1.GET_ACTIVITY_LIST_V2:
        case (0, action_type_util_1.SUCCESS)(types_1.GET_ACTIVITY_LIST_V2):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, activityList: action.payload });
        case types_1.GET_BONUS_ACTIVITY:
        case (0, action_type_util_1.SUCCESS)(types_1.GET_BONUS_ACTIVITY):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, bonusActivity: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_1.GET_ACTIVITY_FEATURED):
            return __assign(__assign({}, state), { loading: false, errorMessage: null, featured: action.payload });
        case types_1.DISMISS_DAILY_BONUS:
            return __assign(__assign({}, state), { dailyBonusRedemption: action.payload.dailyBonusRedemption });
        case (0, action_type_util_1.FAILURE)(types_1.GET_ACTIVITY_LIST_V2):
        case (0, action_type_util_1.FAILURE)(types_1.GET_ACTIVITY_FEATURED):
        case (0, action_type_util_1.FAILURE)(types_1.GET_BONUS_ACTIVITY):
            return __assign(__assign({}, state), { loading: false, errorMessage: action.payload });
        default:
            return state;
    }
};
var persistConfig = {
    key: 'activity-state',
    storage: storage_1.default,
    blacklist: []
};
exports.default = (0, redux_persist_1.persistReducer)(persistConfig, ActivityStateReducer);
//# sourceMappingURL=reducers.js.map